import { cva } from 'class-variance-authority';

import type { VariantProps } from 'class-variance-authority';

import s from './TagPrice.module.css';

const tagPriceVariants = cva(s.wrapper, {
  defaultVariants: {
    color: 'default',
    size: 'base',
  },
  variants: {
    color: {
      default: s.c_default,
    },
    size: {
      base: s.s_base,
    },
  },
});

type TagPriceVariantsProps = VariantProps<typeof tagPriceVariants>;

export { tagPriceVariants, type TagPriceVariantsProps };
